import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import clientSupport from "@features/cashbackWizard2.0/components/images/patrick_av.png";

export const SupportCard = ({
  align = "left",
}: {
  align?: "left" | "center";
}) => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      justifyContent={align === "left" ? "flex-start" : "center"}
    >
      <img
        src={clientSupport}
        title="client-support-avatar"
        width="68"
        height="auto"
        alt="client-support-avatar"
      />
      <Box ml={6} textAlign="left">
        <Typography variant="caption" color="textSecondary" mb={2}>
          {t("supportCard.caption")}
        </Typography>
        <Typography variant="body1">{t("supportCard.title")}</Typography>
        <Typography variant="body3" color="textSecondary">
          {t("supportCard.subtitle")}
        </Typography>
      </Box>
    </Box>
  );
};
